<template>
  <v-card class="px-3 pb-3">
    <v-row class="d-flex justify-space-between ma-0">
      <v-card-title class="headline ma-0" primary-title>{{
        popPupTitle
      }}</v-card-title>
      <v-spacer />
      <div class="pa-2">
        <v-btn v-if="needFullScreenButton" icon color="pink" @click="onFullScreen">
          <v-icon>{{ additionalClass }}</v-icon>
        </v-btn>
        <v-btn icon color="pink" @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-divider></v-divider>
    <dr-layout-placeholder
      ref="drLayoutPlaceHolder"
      :model="{ $ID: 'popup' + this.$route.name, Name: 'PopPup' }"
      @close-dialog="onClose"
    ></dr-layout-placeholder>
  </v-card>
</template>

<script>
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
import actionMixin from '@it-enterprise/web-app-common/src/mixins/actions-mixin'

export default {
  name: 'PopPupLayout',
  mixins: [inputMixin, actionMixin],
  created() {
    const page = this.getPage()
    if (!!page && !!page.MakeOverlayTransparent) {
      document.documentElement.classList.add('pop-up-layout-custom-styles')
    }
    document.documentElement.classList.add('pop-up-layout-is-open')
  },
  beforeDestroy() {
    document.documentElement.classList.remove('pop-up-layout-custom-styles')
    document.documentElement.classList.remove('pop-up-layout-is-open')
  },
  computed: {
    popPupTitle() {
      const page = this.getPage()
      return this.evaluateExpression(page.PopPupTitle)
    },
    additionalClass() {
      const page = this.getPage()
      return page.FullScreenType === 'maximized' ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'
    },
    needFullScreenButton() {
      const page = this.getPage()
      return page.FullScreenType && page.FullScreenType !== 'disabled'
    }
  },
  methods: {
    onClose() {
      const page = this.getPage()
      if (page.OnClosePage) {
        this.invokeActionOnClick(page.OnClosePage)
      }
      this.$emit('close-dialog')
    },
    onFullScreen() {
      const page = this.getPage()
      page.FullScreenType = page.FullScreenType === 'maximized' ? 'minimized' : 'maximized'
    },
    getPage() {
      const popPupId = this.$store.state.appRunner.currentPopPupPageId
      return this.$store.getters.getAllPages.find(x => x.$ID === popPupId)
    }
  }
}
</script>

<style>
.pop-up-layout-is-open {
  overflow: hidden;
}
.pop-up-layout-custom-styles .dr-page .v-overlay .v-overlay__scrim {
  opacity: 0 !important;
}

.pop-up-layout-custom-styles .v-dialog {
  margin: 0px;
  box-shadow: unset;
}

.headline {
  padding: 0px 16px;
}
</style>